// eslint-disable-next-line @typescript-eslint/no-var-requires
// const crypto = require('crypto');

export const hashPassword = (plainText: string) => {
  return plainText;
};
